/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:f20b1161-bdda-4e33-a6e7-2d55d9f2b93d",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_CJf8RXvxK",
    "aws_user_pools_web_client_id": "1nac530h0u9sfnat0opo7q4vhg",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apilabradoodle",
            "endpoint": "https://c08jr1tk0e.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://kunmjqccwvdj7lisaq525icukq.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "labradoodlesamplifysite171613-dev",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
